module.exports = new __parcel__URL__("slack-howto.507c84c6.svg").toString();